export default __webpack_public_path__ + "static/media/zine-avatar7.540511e5.png";